/**
 * Notification Module
 */

import Vue from "vue";
import { apiModel, makeApiRequest } from "../../../api";
let unread_notifications = localStorage.getItem('unread_notifications') != 'undefined' ? JSON.parse(localStorage.getItem('unread_notifications')) : [];
// States
const state = {
    notificationCount: unread_notifications ? unread_notifications.length : 0,
    notifications: unread_notifications,
    notification_alertes: [],
    notification_alerte: {},
};

// Getters
const getters = {

    notification_alertes: state => state.notification_alertes,
    notifications: state => state.notifications,
    notification: state => state.notification,
    notificationCount: state => state.notificationCount,
};

// Actions
const actions = {
    incrementNotificationCount(context){
        context.commit('incrementNotificationCountHandler');
    },
    setAlertes(context,payload){
        context.commit('setAlertesHandler', payload);
    },
    setAlerte(context,payload){
        context.commit('setAlerteHandler', payload);
    },
    MarquezCommeLues(context, args){
        function successCallback(response) {
            context.commit('setReadNotificationsHandler');
        }
        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }
        const localToken = localStorage.getItem('ms-token');
        makeApiRequest(args, {"method": "GET", "url": "/v2/notifications/read_all"}, localToken, successCallback, errorCallback);
    },
    getUnreadNotifications(context, args){
        function successCallback(response) {
            context.commit('getNotificationsHandler', response.data);
        }
        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }
        const localToken = localStorage.getItem('ms-token');
        makeApiRequest(args, {"method": "GET", "url": "/v2/notifications"}, localToken, successCallback, errorCallback);
    },
    deleteAlertes(context, id){
        context.commit('setDeleteAlertesHandler', id);
    }
};

// Mutations
const mutations = {
    getNotificationsHandler(state, notifications) {
        state.notifications = notifications;
    },
    incrementNotificationCountHandler(state){
        state.notificationCount++;
    },
    notificationCountHandler(state, {count}){
        state.notificationCount = count
    },
    decrementNotificationCountHandler(state){
        state.notificationCount--;
    },
    setAlertesHandler(state, alerte){
        state.notification_alertes = [alerte, ...state.notification_alertes];
        state.notificationCount = state.notifications.length + state.notification_alertes.length
    },
    setAlerteHandler(state, alerte){
        state.notification_alerte = alerte;
    },
    setReadNotificationsHandler(state){
        localStorage.setItem('unread_notifications', JSON.stringify([]))
        state.notifications = []
        state.notification_alertes = []
        state.notificationCount = 0
    },
    setDeleteAlertesHandler(state, id){
        state.notification_alertes = state.notification_alertes.filter(item => item.data.id != id);
        state.notifications = state.notifications.filter(item => item.data.id != id);
        state.notificationCount = state.notifications.length + state.notification_alertes.length;
    }

};

export default {
    state,
    getters,
    actions,
    mutations
}